export default __webpack_public_path__ + "locales/ja-JP/Common.json?hash=4c5db65e583f6df9a5ac51c365196906";